// packages/web/src/components/AuthorityGateNotice.tsx — what a refusal that
// became a reach LOOKS like, in one place.
//
// Deliberately plain and deliberately not an error: nothing went wrong. A
// person tried something that is somebody else's to decide, and the system
// took it to them. Canon §2.6 — the system is on the user's side — and §2.7:
// the meaning is in the words, never in a colour.
//
// `role="status"` rather than `role="alert"` for the same reason: this is a
// receipt, and a screen reader should hear it as one.
import type { AuthorityGate } from '../lib/authorityGate';
import { AUTHORITY_GATE_LEAD, authorityGateWords } from '../lib/authorityGate';
import './AuthorityGateNotice.css';

export function AuthorityGateNotice({ gate }: { gate: AuthorityGate | null }) {
  if (!gate) return null;
  return (
    <div class="agn" role="status" data-testid="authority-gate">
      <b class="agn__lead">{AUTHORITY_GATE_LEAD}</b> {authorityGateWords(gate)}
    </div>
  );
}
